import { useApiStore } from "@/stores/api/index.ts";
import { useHttpStore } from "@/stores/http/index.ts";

// if a user does not specify a siteID when they log in we can look up their site from the DB
async function lookupUserSiteID(dispatch) {
  const api = useApiStore();
  const httpStore = useHttpStore();
  const isAuthenticated = await httpStore.auth0Client.isAuthenticated();
  if (isAuthenticated) {
    const { data } = await dispatch("httpRequest", {
      func: api.lookupSiteId(),
      config: {
        isCms: false,
        isAuth: true,
      },
    });
    return data.siteID;
  }
  return "";
}

const setSiteId = async (module, siteId) => {
  const { dispatch } = module;

  let newSiteId = siteId;

  if (siteId === "lookup") {
    newSiteId = await lookupUserSiteID(dispatch);
  }

  await dispatch("setStyleID", newSiteId, { root: true });
};

export { setSiteId };
